
import { passwordStrength, defaultOptions } from 'check-password-strength'

// Define the structure of the return value
interface PasswordValidationResult {
  isValid: boolean
  details: {
    hasUppercase: boolean
    hasLowercase: boolean
    hasNumbers: boolean
    hasSpecialChar: boolean
  }
}

export const validatePassword = (
  password: string
): PasswordValidationResult => {
  // Handle empty passwords
  if (!password) {
    return {
      isValid: false,
      details: {
        hasUppercase: false,
        hasLowercase: false,
        hasNumbers: false,
        hasSpecialChar: false,
      },
    }
  }

  const hasUppercase = /[A-Z]/.test(password)
  const hasLowercase = /[a-z]/.test(password)
  const hasNumbers = /\d/.test(password)
  const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)

  const result = passwordStrength(password, [...defaultOptions, {
    id: 4,
    value: 'Special Char',
    minLength: 8,
    minDiversity: 4,
  }])


  return {
    isValid: result.value === 'Special Char',
    details: {
      hasUppercase,
      hasLowercase,
      hasNumbers,
      hasSpecialChar,
    },
  }
}
